import { Box, styled } from '@mui/material';

export const TabStripRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: 24,
  borderBottom: `1px solid ${theme.palette.grey.A400}`,
  padding: '16px 40px 0',
  background: theme.palette.common.white,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  borderLeft: `1px solid ${theme.palette.grey.A400}`,
  borderRight: `1px solid ${theme.palette.grey.A400}`,
  borderTop: `1px solid ${theme.palette.grey.A400}`,
}));

export const TabsScrollerWrapper = styled(Box)({
  position: 'relative',
  flex: '1 1 0',
  minWidth: 0,
});

export const TabsScroller = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  gap: 40,
  minWidth: 0,
  overflowX: 'auto',
  overflowY: 'hidden',
  // The scrollbar would otherwise sit under the fade and read as a stray line.
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
});

/** Signals that tabs continue underneath the action buttons. Rendered only
 * while the strip is actually scrollable and not yet scrolled to the end. */
export const TabsScrollFade = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  width: 64,
  pointerEvents: 'none',
  background: `linear-gradient(to right, rgba(255,255,255,0) 0%, ${theme.palette.common.white} 100%)`,
}));

export const TabStripActions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  alignSelf: 'center',
  paddingBottom: 8,
  flexShrink: 0,
  '& > *': {
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  '& .MuiButtonGroup-root': {
    width: 'auto',
  },
});

export const TabButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  padding: '10px 0',
  height: 56,
  fontSize: 12,
  lineHeight: '20px',
  letterSpacing: 0,
  fontWeight: isActive ? 700 : 400,
  textTransform: 'uppercase',
  color: isActive ? '#2085FF' : '#6E7071',
  borderBottom: isActive ? '2px solid #2085FF' : '2px solid transparent',
  whiteSpace: 'nowrap',
  fontFamily: 'inherit',
  '&:hover': {
    color: '#2085FF',
  },
  '& .goal-type-icon': {
    fontSize: 16,
    color: 'inherit',
    flexShrink: 0,
  },
  '&:disabled': {
    color: theme.palette.grey.A500,
    cursor: 'default',
  },
}));

export const TabLabel = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
});
